{
  "login": {
    "title": "Anmelden",
    "emailLabel": "E-Mail-Adresse",
    "passwordLabel": "Passwort",
    "rememberMe": "Für 30 Tage angemeldet bleiben",
    "submitButton": "Anmelden",
    "submittingButton": "Anmeldung läuft...",
    "forgotPassword": "Passwort vergessen?",
    "setNewPassword": "Hier ein neues Passwort festlegen",
    "sessionExpired": "Sitzung abgelaufen",
    "noAccountYet": "Noch kein Konto?",
    "createOne": "Jetzt erstellen"
  },
  "forgotPassword": {
    "title": "Passwort vergessen",
    "emailLabel": "E-Mail-Adresse",
    "submitButton": "Passwort-Reset-Link an deine E-Mail senden",
    "backToLogin": "Zurück zur Anmeldung",
    "submittingButton": "Wird gesendet...",
    "successTitle": "Prüfe dein E-Mail-Postfach",
    "successMessage": "Falls ein Konto mit dieser Adresse existiert, haben wir dir einen Link zum Zurücksetzen per E-Mail geschickt."
  },
  "confirmEmail": {
    "confirming": "Deine E-Mail wird bestätigt…",
    "successTitle": "E-Mail bestätigt",
    "successMessage": "Deine E-Mail-Adresse wurde bestätigt. Du kannst dich jetzt anmelden.",
    "continueToLogin": "Weiter zur Anmeldung",
    "errorTitle": "Bestätigung fehlgeschlagen",
    "errorMessage": "Wir konnten deine E-Mail nicht bestätigen. Der Link ist möglicherweise ungültig oder abgelaufen."
  },
  "resetPassword": {
    "title": "Passwort zurücksetzen",
    "subtitle": "Gib unten dein neues Passwort ein",
    "newPasswordLabel": "Neues Passwort",
    "newPasswordPlaceholder": "Gib dein neues Passwort ein",
    "confirmPasswordLabel": "Neues Passwort bestätigen",
    "confirmPasswordPlaceholder": "Bestätige dein neues Passwort",
    "passwordsDoNotMatch": "Passwörter stimmen nicht überein",
    "submitButton": "Neues Passwort festlegen",
    "submittingButton": "Passwort wird zurückgesetzt...",
    "invalidToken": "Ungültiger Reset-Token",
    "fixRequirements": "Bitte erfülle die Passwortanforderungen",
    "failedReset": "Passwort konnte nicht zurückgesetzt werden"
  },
  "acceptTerms": {
    "title": "Nutzungsbedingungen",
    "subtitle": "Bitte lies und akzeptiere unsere Bedingungen, um fortzufahren",
    "welcomeTitle": "Willkommen bei Flipping Pal!",
    "welcomeBody": "Diese Nutzungsbedingungen legen die Regeln und Vorschriften für die Nutzung der Website von Flipping Pal unter",
    "welcomeBody2": "fest. Durch den Zugriff auf diese Website gehen wir davon aus, dass du diese Nutzungsbedingungen akzeptierst. Nutze Flipping Pal nicht weiter, wenn du nicht allen auf dieser Seite genannten Nutzungsbedingungen zustimmst.",
    "keyPointsTitle": "Wichtige Punkte:",
    "keyPoints": {
      "0": "Flipping Pal besitzt alle Rechte am geistigen Eigentum der Materialien auf dieser Website",
      "1": "Du darfst keine Inhalte von Flipping Pal neu veröffentlichen, verkaufen oder weiterverbreiten",
      "2": "Wir verwenden Cookies, um dein Erlebnis auf unserer Website zu verbessern",
      "3": "Nutzerkommentare spiegeln nicht die Ansichten von Flipping Pal wider",
      "4": "Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern",
      "5": "Website-Inhalte werden \"wie gesehen\" ohne Garantien bereitgestellt"
    },
    "responsibilitiesTitle": "Deine Pflichten:",
    "responsibilities": {
      "0": "Nutze den Dienst in Übereinstimmung mit allen geltenden Gesetzen",
      "1": "Halte die Sicherheit deiner Kontodaten aufrecht",
      "2": "Versuche nicht, die Sicherheit unserer Systeme zu gefährden",
      "3": "Respektiere geistige Eigentumsrechte"
    },
    "previewNote": "📄 Dies ist eine Vorschau unserer Nutzungsbedingungen. Klicke unten auf \"Vollständige Bedingungen anzeigen\", um das vollständige Dokument zu lesen.",
    "viewFullTerms": "Vollständige Nutzungsbedingungen anzeigen (öffnet in neuem Tab)",
    "checkboxLabel": "Ich habe die Nutzungsbedingungen gelesen und stimme ihnen zu",
    "checkboxDescription": "Durch Ankreuzen dieses Kästchens bestätigst du, dass du diese Bedingungen gelesen, verstanden hast und damit einverstanden bist, an sie gebunden zu sein.",
    "acceptButton": "Akzeptieren und weiter",
    "acceptingButton": "Wird akzeptiert...",
    "questionsText": "Fragen zu unseren Bedingungen?",
    "contactSupport": "Support kontaktieren"
  },
  "discord": {
    "linkingTitle": "Discord-Konto wird verknüpft",
    "linkingBody": "Bitte warte, während wir dein Discord-Konto verbinden...",
    "successTitle": "Erfolgreich!",
    "successBody": "Dein Discord-Konto wurde erfolgreich verknüpft.",
    "successWindowClose": "Dieses Fenster schliesst sich automatisch...",
    "successRedirect": "Du wirst zurück zu den Einstellungen weitergeleitet...",
    "errorTitle": "Verknüpfung fehlgeschlagen",
    "errorBody": "Wir konnten dein Discord-Konto nicht verknüpfen.",
    "errorWindowClose": "Dieses Fenster schliesst sich automatisch...",
    "errorRedirect": "Du wirst zurück zu den Einstellungen weitergeleitet...",
    "backToSettings": "Zurück zu den Einstellungen"
  },
  "register": {
    "title": "Konto erstellen",
    "subtitle": "Registriere dich und beginne deine Reise noch heute",
    "emailLabel": "E-Mail-Adresse",
    "emailPlaceholder": "E-Mail-Adresse eingeben",
    "passwordLabel": "Passwort",
    "passwordPlaceholder": "Sicheres Passwort erstellen",
    "confirmPasswordLabel": "Passwort bestätigen",
    "confirmPasswordPlaceholder": "Passwort bestätigen",
    "passwordStrength": "Passwortstärke",
    "strengthStrong": "Stark",
    "strengthMedium": "Mittel",
    "strengthWeak": "Schwach",
    "termsLabel": "Ich stimme den",
    "termsLink": "Nutzungsbedingungen",
    "termsLabel2": "zu",
    "submitButton": "Konto erstellen",
    "submittingButton": "Konto wird erstellt...",
    "alreadyHaveAccount": "Bereits ein Konto vorhanden?",
    "signInHere": "Hier einloggen",
    "registrationClosed": "Derzeit keine Registrierung möglich",
    "registrationClosedMessage": "Momentan ist die Registrierung geschlossen",
    "fixFormErrors": "Bitte behebe die Formularfehler vor dem Absenden",
    "acceptTermsRequired": "Bitte akzeptiere die Nutzungsbedingungen, um fortzufahren",
    "registrationFailed": "Registrierung fehlgeschlagen. Bitte erneut versuchen."
  },
  "errorBoundary": {
    "title": "Etwas ist schiefgelaufen",
    "subtitle": "Ein unerwarteter Fehler ist aufgetreten. Keine Sorge – deine Daten sind sicher.",
    "unknownError": "Unbekannter Fehler",
    "goHome": "Zur Startseite",
    "reloadPage": "Seite neu laden",
    "logout": "Abmelden",
    "showErrorDetails": "Fehlerdetails anzeigen",
    "hideErrorDetails": "Fehlerdetails ausblenden",
    "copyToClipboard": "In Zwischenablage kopieren",
    "copied": "Kopiert!",
    "copy": "Kopieren",
    "errorLabel": "Fehler",
    "componentStackLabel": "Komponenten-Stack",
    "reference": "Referenz"
  }
}
